export default "__VITE_ASSET__3SoCJERm__"